import React, { useEffect, useState } from "react";
import { OVERVIEW, ADA } from "../../../core/theme/reportTheme";
import AdaAvatar from "../../../core/layout/AdaAvatar";
import wordmark from "../../../assets/brand/ada-wordmark.svg";

// How long AdA "types" before the facts appear, and the gap between facts.
const TYPING_MS = 1000;
const FACT_STAGGER_MS = 140;

// "AdA. OBSERVED": AdA's circle, the AdA. wordmark, a typing bubble for a
// moment, then the facts appearing one after another as if AdA is saying
// them. Replays whenever the facts change (e.g. a filter changes).
// Used on Market Overview and Advertiser Overview. AdA is always written
// "AdA" on screen (capital A, small d, capital A).
//   facts: [{ id, label, value, title }]   suffix: " so far" while running
//   right: anything for the right-hand end (e.g. the copy-result button)
export default function AdaObserved({ facts, suffix = "", labelTitle, right }) {
  const factsKey = facts.map(f => `${f.id}|${f.label}|${f.value}`).join("\n");
  const [typing, setTyping] = useState(true);

  useEffect(() => {
    if (prefersReducedMotion()) { setTyping(false); return undefined; }
    setTyping(true);
    const timer = setTimeout(() => setTyping(false), TYPING_MS);
    return () => clearTimeout(timer);
  }, [factsKey]);

  return (
    <div className={ADA.row}>
      <AdaAvatar size={1.5} />
      <span className={ADA.label} title={labelTitle}>
        <img src={wordmark} alt="AdA." className={ADA.wordmark} />
        <span className={OVERVIEW.factLabel}>Observed{suffix}</span>
      </span>
      <div className={ADA.facts}>
        {typing ? (
          <span className={ADA.typing} aria-label="AdA is typing">
            <span className={ADA.dot} style={{ animationDelay: "0ms" }} />
            <span className={ADA.dot} style={{ animationDelay: "150ms" }} />
            <span className={ADA.dot} style={{ animationDelay: "300ms" }} />
          </span>
        ) : facts.length === 0 ? (
          <span className={`${ADA.appear} text-xs text-slate-400`}>Nothing to report yet.</span>
        ) : (
          facts.map((f, i) => (
            <span key={f.id} className={`${OVERVIEW.fact} ${ADA.appear}`} style={{ animationDelay: `${i * FACT_STAGGER_MS}ms` }} title={f.title}>
              {f.label} <span className={OVERVIEW.factValue}>{f.value}</span>
            </span>
          ))
        )}
      </div>
      {right}
    </div>
  );
}

function prefersReducedMotion() {
  return typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
